import React from 'react'

import { useAPIGetPerencanaanSatuanPendidikanOptions } from 'api/kinerja/pengawas-sekolah/perencanaan'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

import type { TSatuanPendidikanItem } from 'types/kinerja-ps-pegawai'
type TUseSatuanPendidikanProps = {
  rhkId?: string | undefined
}
type TUseSatuanPendidikanHooks = {
  satuanPendidikanData: TSatuanPendidikanItem[]
}
export const useSatuanPendidikan = ({
  rhkId,
}: TUseSatuanPendidikanProps): TUseSatuanPendidikanHooks => {
  const { isHavePeriod, period } = usePeriodContext()

  const {
    data: perencanaanSatuanPendidikanResponse,
    isSuccess: isPerencanaanSatuanPendidikanSuccess,
  } = useAPIGetPerencanaanSatuanPendidikanOptions({
    periodeId: period.id,
    rhkId,
    opts: {
      enabled: isHavePeriod && Boolean(rhkId) && rhkId !== '0',
    },
  })

  const satuanPendidikanData = React.useMemo(() => {
    if (isPerencanaanSatuanPendidikanSuccess) {
      return perencanaanSatuanPendidikanResponse?.data ?? []
    }

    return []
  }, [
    isPerencanaanSatuanPendidikanSuccess,
    perencanaanSatuanPendidikanResponse?.data,
  ])

  return {
    satuanPendidikanData,
  }
}
